import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as L}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as l}from"../../icon-registry.js";const p=l("cook_islands",L`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <g clip-path="url(#clip0_19477_92892)">
                <path
                    d="M-0.000488281 4.5L23.9999 4.5L23.9999 20.5L-0.000488281 20.5L-0.000488281 4.5Z"
                    fill="#012169" />
                <path
                    d="M19.2031 8.44922L19.3994 8.95196H20.0317L19.5205 9.26087L19.7168 9.76362L19.2031 9.4547L18.6895 9.76362L18.8857 9.26087L18.3745 8.95196H19.0069L19.2031 8.44922Z"
                    fill="white" />
                <path
                    d="M21.165 8.79788L21.0989 9.32366L21.6765 9.538L21.0587 9.64694L20.9926 10.1727L20.6742 9.71643L20.0542 9.82454L20.4789 9.43177L20.1626 8.97628L20.7403 9.19062L21.165 8.79785V8.79788Z"
                    fill="white" />
                <path
                    d="M22.7888 9.77931L22.4718 10.2372L22.8949 10.6288L22.2774 10.519L21.9604 10.9769L21.8921 10.4521L21.2729 10.3407L21.8526 10.1258L21.786 9.60254L22.2091 9.99415L22.7888 9.77928V9.77931Z"
                    fill="white" />
                <path
                    d="M23.7911 11.2279L23.278 11.5388L23.4734 12.04L22.9629 11.7303L22.4497 12.0412L22.6436 11.5386L22.1323 11.227L22.7667 11.2272L22.9613 10.7266L23.1567 11.2277L23.7911 11.2279Z"
                    fill="white" />
                <path
                    d="M24.0007 12.8916L23.3802 13.0017L23.3141 13.5258L22.9989 13.0698L22.3784 13.1799L22.8008 12.7865L22.4858 12.3285L23.0653 12.5437L23.4874 12.1523L23.4213 12.6764L24.0007 12.8916H24.0007Z"
                    fill="white" />
                <path
                    d="M23.3801 14.482L22.7595 14.3723L22.4433 14.8286L22.3779 14.3052L21.7573 14.1955L22.3352 13.9792L22.271 13.4541L22.6953 13.8471L23.2719 13.6326L22.9557 14.089L23.3801 14.482Z"
                    fill="white" />
                <path
                    d="M22.0374 15.7251L21.5241 15.4145L21.0125 15.7243L21.2082 15.2239L20.6948 14.9133L21.3283 14.9117L21.5259 14.4102L21.7217 14.913L22.3532 14.9125L21.8416 15.2223L22.0375 15.7251H22.0374Z"
                    fill="white" />
                <path
                    d="M20.2089 16.405L19.8915 15.9472L19.2729 16.0568L19.6959 15.666L19.3785 15.2083L19.958 15.4214L20.3833 15.0303L20.3168 15.556L20.8939 15.7696L20.2754 15.8792L20.2089 16.405Z"
                    fill="white" />
                <path
                    d="M18.2002 16.405L18.1337 15.8792L17.5151 15.7696L18.0922 15.556L18.0257 15.0303L18.4511 15.4214L19.0305 15.2083L18.7131 15.666L19.1361 16.0568L18.5176 15.9472L18.2002 16.405Z"
                    fill="white" />
                <path
                    d="M16.366 15.7251L16.5619 15.2223L16.0503 14.9125L16.6818 14.913L16.8776 14.4102L17.0753 14.9117L17.7087 14.9133L17.1953 15.2239L17.391 15.7243L16.8794 15.4145L16.3661 15.7251H16.366Z"
                    fill="white" />
                <path
                    d="M15.0229 14.482L15.4473 14.089L15.1311 13.6326L15.7077 13.8471L16.132 13.4541L16.0678 13.9792L16.6457 14.1955L16.0251 14.3052L15.9597 14.8286L15.6435 14.3723L15.0229 14.482Z"
                    fill="white" />
                <path
                    d="M14.4019 12.8916L14.9813 12.6764L14.9152 12.1523L15.3373 12.5437L15.9168 12.3285L15.6018 12.7865L16.0242 13.1799L15.4037 13.0698L15.0885 13.5258L15.0224 13.0017L14.4019 12.8916H14.4019Z"
                    fill="white" />
                <path
                    d="M14.6089 11.2279L15.2433 11.2277L15.4387 10.7266L15.6333 11.2272L16.2676 11.227L15.7564 11.5386L15.9502 12.0412L15.4371 11.7303L14.9266 12.04L15.122 11.5388L14.6089 11.2279Z"
                    fill="white" />
                <path
                    d="M15.6135 9.78026L16.1931 9.99512L16.6162 9.60352L16.5496 10.1268L17.1293 10.3417L16.5101 10.4531L16.4419 10.9779L16.1249 10.5199L15.5073 10.6298L15.9305 10.2382L15.6135 9.78028V9.78026Z"
                    fill="white" />
                <path
                    d="M17.2376 8.79688L17.6623 9.18964L18.24 8.9753L17.9237 9.43079L18.3484 9.82356L17.7284 9.71545L17.41 10.1717L17.3439 9.64596L16.7261 9.53703L17.3037 9.32269L17.2376 8.7969V8.79688Z"
                    fill="white" />
                <path
                    d="M14.3992 4.5L-0.000488281 4.5L-0.000488281 10.5L14.3992 10.5L14.3992 4.5Z"
                    fill="#012169" />
                <path
                    d="M-0.000488281 5.16999L3.18904 6.49998H-0.000488281L-0.000488281 8.49999H3.18904L-0.000488281 9.83001L-0.000488281 10.5H1.60988L5.99941 8.67V10.5L8.39937 10.5L8.39937 8.67L12.7888 10.5L14.3992 10.5L14.3992 9.83001L11.2097 8.50002L14.3992 8.50002V6.50001L11.2601 6.48L14.3992 5.16999V4.5L12.7888 4.5L8.39937 6.33V4.5L5.99941 4.5L6.00422 6.33601L1.60988 4.5H-0.000488281L-0.000488281 5.16999Z"
                    fill="white" />
                <path
                    d="M1.07228 10.5L5.87218 8.5H4.79941L-0.000488281 10.5H1.07228Z"
                    fill="#C8102E" />
                <path
                    d="M3.72664 6.50001L4.79941 6.50001L-0.000488281 4.5L-0.000488281 4.94801L3.72664 6.50001Z"
                    fill="#C8102E" />
                <path
                    d="M8.52686 6.50001H9.59963L14.3995 4.5H13.3267L8.52686 6.50001Z"
                    fill="#C8102E" />
                <path
                    d="M14.401 10.5L9.60107 8.5H10.6738L14.401 10.052V10.5Z"
                    fill="#C8102E" />
                <path
                    d="M-0.000488281 6.9L6.47939 6.9V4.5H7.91936V6.9H14.3992V8.1H7.91936V10.5H6.47939V8.1H-0.000488281L-0.000488281 6.9Z"
                    fill="#C8102E" />
            </g>
            <defs>
                <clipPath id="clip0_19477_92892">
                    <rect
                        width="24"
                        height="24"
                        fill="white"
                        transform="translate(0 0.5)" />
                </clipPath>
            </defs>
        </svg>
    `),a=l("cook_islands_rounded",L`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <g clip-path="url(#clip0_19477_92907)">
                <rect
                    y="0.5"
                    width="24"
                    height="24"
                    rx="12"
                    fill="#FF4E4E" />
                <path
                    d="M0 0.5L24 0.5L24 24.5L0 24.5L0 0.5Z"
                    fill="#012169" />
                <path
                    d="M18.0006 6.4248L18.2459 7.17892H19.0364L18.3974 7.64229L18.6427 8.3964L18.0006 7.93303L17.3585 8.3964L17.6039 7.64229L16.9648 7.17892H17.7553L18.0006 6.4248Z"
                    fill="white" />
                <path
                    d="M20.4549 6.9473L20.3723 7.73598L21.0944 8.05749L20.3221 8.2209L20.2395 9.00958L19.8414 8.32513L19.0664 8.48729L19.5972 7.89814L19.2019 7.2149L19.924 7.53642L20.4549 6.94727V6.9473Z"
                    fill="white" />
                <path
                    d="M22.4846 8.42043L22.0884 9.10732L22.6173 9.69473L21.8454 9.52991L21.4491 10.2168L21.3638 9.42961L20.5898 9.26252L21.3144 8.94023L21.2312 8.15527L21.7601 8.74268L22.4846 8.42039V8.42043Z"
                    fill="white" />
                <path
                    d="M23.7376 10.5929L23.0962 11.0592L23.3404 11.811L22.7022 11.3464L22.0609 11.8128L22.3031 11.0589L21.6641 10.5915L22.4571 10.5918L22.7003 9.84082L22.9445 10.5926L23.7376 10.5929Z"
                    fill="white" />
                <path
                    d="M24.0005 13.0884L23.2249 13.2535L23.1423 14.0397L22.7483 13.3557L21.9727 13.5209L22.5006 12.9308L22.1069 12.2438L22.8312 12.5666L23.3589 11.9795L23.2762 12.7656L24.0006 13.0884H24.0005Z"
                    fill="white" />
                <path
                    d="M23.2238 15.4745L22.448 15.3098L22.0528 15.9944L21.971 15.2093L21.1953 15.0447L21.9176 14.7203L21.8374 13.9326L22.3678 14.5221L23.0886 14.2004L22.6934 14.8849L23.2238 15.4745Z"
                    fill="white" />
                <path
                    d="M21.5455 17.3377L20.9038 16.8718L20.2643 17.3364L20.5089 16.5859L19.8672 16.12L20.659 16.1175L20.9061 15.3652L21.1509 16.1195L21.9402 16.1188L21.3007 16.5834L21.5455 17.3377H21.5455Z"
                    fill="white" />
                <path
                    d="M19.2559 18.3579L18.8591 17.6713L18.0859 17.8356L18.6146 17.2495L18.2179 16.5629L18.9423 16.8826L19.474 16.2959L19.3908 17.0845L20.1122 17.4049L19.339 17.5693L19.2559 18.3579Z"
                    fill="white" />
                <path
                    d="M16.747 18.3579L16.6638 17.5693L15.8906 17.4049L16.612 17.0845L16.5289 16.2959L17.0606 16.8826L17.7849 16.5629L17.3882 17.2495L17.9169 17.8356L17.1437 17.6713L16.747 18.3579Z"
                    fill="white" />
                <path
                    d="M14.4533 17.3387L14.6981 16.5844L14.0586 16.1198L14.8479 16.1205L15.0927 15.3662L15.3398 16.1185L16.1316 16.121L15.4899 16.5869L15.7345 17.3374L15.095 16.8728L14.4533 17.3387H14.4533Z"
                    fill="white" />
                <path
                    d="M12.7773 15.4745L13.3078 14.8849L12.9125 14.2004L13.6333 14.5221L14.1637 13.9326L14.0835 14.7203L14.8058 15.0447L14.0301 15.2093L13.9483 15.9944L13.5531 15.3098L12.7773 15.4745Z"
                    fill="white" />
                <path
                    d="M12 13.0884L12.7243 12.7656L12.6417 11.9795L13.1694 12.5666L13.8937 12.2438L13.5 12.9308L14.0279 13.5209L13.2523 13.3557L12.8583 14.0397L12.7757 13.2535L12 13.0884H12Z"
                    fill="white" />
                <path
                    d="M12.2617 10.5919L13.0547 10.5916L13.299 9.83984L13.5422 10.5908L14.3352 10.5905L13.6961 11.058L13.9384 11.8118L13.297 11.3454L12.6589 11.81L12.9031 11.0582L12.2617 10.5919Z"
                    fill="white" />
                <path
                    d="M13.5155 8.42039L14.24 8.74268L14.7689 8.15527L14.6857 8.94023L15.4103 9.26252L14.6363 9.42961L14.551 10.2168L14.1547 9.52991L13.3828 9.69473L13.9117 9.10732L13.5155 8.42043V8.42039Z"
                    fill="white" />
                <path
                    d="M15.5457 6.94531L16.0766 7.53446L16.7987 7.21295L16.4034 7.89619L16.9342 8.48534L16.1592 8.32318L15.7611 9.00762L15.6785 8.21894L14.9062 8.05554L15.6283 7.73403L15.5457 6.94535V6.94531Z"
                    fill="white" />
                <path
                    d="M12 0.5L-6 0.5L-6 9.5L12 9.5V0.5Z"
                    fill="#012169" />
                <path
                    d="M-6 1.50499L-2.01302 3.49997L-6 3.49997V6.49999L-2.01302 6.49999L-6 8.49502L-6 9.5H-3.987L1.50001 6.755L1.50001 9.5H4.50003V6.755L9.98695 9.5L12 9.5V8.49502L8.01302 6.50003H12V3.50001L8.07599 3.47L12 1.50499V0.5L9.98695 0.5L4.50003 3.245V0.5L1.50001 0.5L1.50604 3.25401L-3.987 0.5L-6 0.5V1.50499Z"
                    fill="white" />
                <path
                    d="M-4.65901 9.50002L1.34098 6.5H-1.4782e-05L-6 9.50002H-4.65901Z"
                    fill="#C8102E" />
                <path
                    d="M4.66016 3.50001H6.00115L12.0011 0.5L10.6601 0.5L4.66016 3.50001Z"
                    fill="#C8102E" />
                <path
                    d="M12 9.50002L6 6.5H7.34099L12 8.828V9.50002Z"
                    fill="#C8102E" />
                <path
                    d="M-6 4.1L2.1 4.1V0.5L3.9 0.5V4.1L12 4.1V5.9L3.9 5.9L3.9 9.5H2.1L2.1 5.9L-6 5.9V4.1Z"
                    fill="#C8102E" />
            </g>
            <defs>
                <clipPath id="clip0_19477_92907">
                    <rect
                        y="0.5"
                        width="24"
                        height="24"
                        rx="12"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>
    `);export{p as CookIslands,a as CookIslandsRounded};
